<lh-product-finder
  (productSelected)="onProductSelected($event)"
  (searchError)="onError($event)"
>
</lh-product-finder>
